export const data = [
    {
        img : "https://res.cloudinary.com/dswxpp4qr/image/upload/2_zcrf05.png",
        disc : "A modern e-commerce platform where businesses can list products and sell them to customers worldwide",
        link: "https://agent-spt.com/"
    },
    {
        img : "https://res.cloudinary.com/dswxpp4qr/image/upload/1_r1gfri.webp",
        disc : "A professional web solutions platform where you can get high-quality websites, web apps, and digital services tailored to your business needs",
        link: "https://netsflow.netlify.app/"
    },
    {
        img : "https://res.cloudinary.com/dswxpp4qr/image/upload/4_fyoa0q.webp",
        disc : "A video library where you can watch your favourite movies, series etc. You also able to add videos to watch later",
        link: "https://fast-streaming-site.netlify.app/"
    },
    {
        img : "https://res.cloudinary.com/dswxpp4qr/image/upload/5_bhg7or.webp",
        disc : "A college admissions guidance platform where students get expert strategies and personalized planning to improve their chances of getting into top universities",
        link: "https://www.collegemastermind.com/"
    },
];

export const settings = {
    className: "center",
    centerMode: true,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows : false,
    responsive: [
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          centerMode : false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          centerMode : false
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode : false
        }
      }
    ]
  };